import { Reveal } from "./Reveal";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="relative py-32 lg:py-44 border-t border-white/5 overflow-hidden">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(ellipse 55% 60% at 50% 55%, rgba(0,240,255,0.07), transparent 60%), radial-gradient(ellipse 40% 45% at 50% 80%, rgba(138,43,226,0.1), transparent 60%)" }}
    />
    <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
      <Reveal>
        <h2 className="font-display font-extrabold uppercase leading-[0.98] tracking-tight text-[clamp(1.5rem,7.2vw,2.25rem)] sm:text-6xl lg:text-7xl text-slate-100" data-testid="final-cta-headline">
          Your next opportunity could be{" "}
          <span className="text-transparent bg-clip-text" style={{ backgroundImage: "linear-gradient(92deg, #00F0FF 10%, #8A2BE2 90%)" }}>
            one connection
          </span>{" "}
          away.
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-col sm:flex-row justify-center gap-4">
          <a href="/post?type=need" data-testid="final-cta-need-btn" className="btn-primary">
            I Need Something
          </a>
          <a href="/post?type=offer" data-testid="final-cta-offer-btn" className="btn-ghost">
            I Can Offer Something
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="mt-16 flex items-center justify-center gap-4">
          <span className="font-display font-bold tracking-[0.25em] text-sm text-slate-300">FINDXCHANGE</span>
          <span className="text-[#00F0FF]">✕</span>
          <span className="font-mono-accent text-[11px] tracking-[0.3em] text-slate-500">FIND. CONNECT. GROW.</span>
        </div>
      </Reveal>
    </div>
  </section>
);
